import { FormControl, FormLabel, TextField } from '@mui/material';
import { useCatalogFilters } from '@/packages/courses/context/catalog-filters';
import type { FilterSchemaPrice } from '@/packages/courses/types/schema';

interface FilterPriceProps extends FilterSchemaPrice {
  id: 'price_min' | 'price_max';
}

export const FilterPrice = ({ id, title }: FilterPriceProps) => {
  const { params, actions } = useCatalogFilters();
  const value = params[id]?.[0] ?? '';

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const v = event.target.value.replace(/\D/g, '');
    const num = v ? parseInt(v, 10) : undefined;
    actions.setParam(
      id,
      num != null && !Number.isNaN(num) ? [String(num)] : undefined
    );
  };

  const labelId = `${id}-label`;

  return (
    <FormControl fullWidth aria-labelledby={labelId}>
      <FormLabel id={labelId} htmlFor={id}>
        {title}
      </FormLabel>
      <TextField
        id={id}
        size="small"
        type="text"
        inputMode="numeric"
        placeholder="0,00"
        value={value}
        onChange={handleChange}
        slotProps={{
          input: { startAdornment: 'R$ ' },
          htmlInput: { 'aria-labelledby': labelId },
        }}
      />
    </FormControl>
  );
};
